import { Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { DefaultNavLinks } from "pages/NavLinks";
import { useLocation, useNavigate } from "react-router-dom";
import { useSessionStore } from "stores/userSessionStore";

import classes from "./DefaultHeader.module.css";

const DefaultHeader = () => {
  const [opened, { toggle }] = useDisclosure(false);
  const navigate = useNavigate();
  const { isLoggedIn } = useSessionStore();
  const location = useLocation();

  const visibleItems = DefaultNavLinks.filter(
    (item) => !item.restrictedToMembers || isLoggedIn
  );
  const items = visibleItems.map((link) => {
    const isActive =
      location.pathname === link.link ||
      location.pathname.startsWith(`${link.link}/`);

    return (
      <a
        key={link.label}
        href={link.link}
        className={`${classes.link} ${isActive ? classes.activeLink : ""}`}
        onClick={(event) => {
          navigate(link.link);
          event.preventDefault();
        }}
      >
        {link.label}
      </a>
    );
  });

  return (
    <Group
      ml={50}
      gap={5}
      w="100%"
      style={{
        alignItems: "center",
        justifyContent: "center",
      }}
      className={classes.links}
      visibleFrom="sm"
    >
      {items}
    </Group>
  );
};
export default DefaultHeader;
// This component serves as the default header for the application.
// It includes a logo and can be extended with navigation items or other header elements.
// The header is styled with Tailwind CSS classes for a clean and modern look.
